module.exports = __webpack_public_path__ + "static/media/tortue1rose.d15712bf.png";